import { A } from '@adornis/base/env-info.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import { setDefaultOptions } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { Settings as LuxonSettings } from 'luxon';

let initialized = false;

export function initDateLocale(): void {
  if (!A.isClient || initialized) return;
  initialized = true;

  // The language subject emits its current value synchronously, before the first render.
  globalLanguageSubject.subscribe(language => {
    const locale = language === Language.GERMAN ? de : enUS;
    setDefaultOptions({ locale });
    LuxonSettings.defaultLocale = locale.code;
  });
}
